module.exports= {
	map_poi: require("./map_poi"),
	platform_images: require("./platform_images"),
	device_images: require("./device_images")
};